import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";

export default function ListHeader() {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();

  const theme = useTheme();

  const styles: {
    container: React.CSSProperties;
    text: React.CSSProperties;
  } = {
    container: {
      backgroundColor: theme.listTitleColor,
      paddingTop: 15,
      paddingBottom: 15,
    },
    text: {
      color: "white",
      textAlign: "center",
      fontWeight: "lighter",
    },
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: isSmallLayout || isMediumLayout ? "100%" : "80%",
          }}
        >
          <Grid2 container alignItems="center">
            <Grid2 xs>
              <h2 style={styles.text}>App</h2>
            </Grid2>
            <Grid2 xs>
              <h2 style={styles.text}>Platform / rel. S.O.</h2>
            </Grid2>
            <Grid2 xs>
              <h2 style={styles.text}>Store</h2>
            </Grid2>
            <Grid2 xs>
              <h2 style={styles.text}>Authentication</h2>
            </Grid2>
            <Grid2 xs>
              <h2 style={styles.text}>ERP</h2>
            </Grid2>
          </Grid2>
        </div>
      </div>
    </div>
  );
}
